import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfo } from '@models/auth.model';
import { LoaderService } from '@services/loader.service';
import { PermissionsService } from '@services/permissions.service';
import { Observable, delay } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  loading$ = inject(LoaderService).loading.pipe(delay(100));

  isLoggedIn$ = new Observable<UserInfo | Record<string, never>>();

  constructor(private permissionService: PermissionsService, private router: Router) {
    this.isLoggedIn$ = this.permissionService.userInfo;
    // this.router.events.subscribe({
    //   next: console.log
    // })
  }
}
